import dayjs from "dayjs";
import { RedoxCategoryType } from "DataTypes/PatientManagement.type";
import {
  CatSearchDocType,
  CategorySearchType,
} from "DataTypes/Services/Redox.type";

const FormatCatSearch: (
  res: CategorySearchType,
  arr: RedoxCategoryType[]
) => RedoxCategoryType[] = (res, arr) => {
  return arr.map((el) => {
    const filter = res.response.filter((el1) => el1.documentType == el.docKey);
    return {
      ...el,
      docList: filter,
      count: res.facet_counts.facet_fields.documentType[el.countKey],
    };
  });
};

/**
 * The line under a document's name that tells two identically-named documents apart.
 *
 * Athena names documents by TYPE, not uniquely. One patient on QA has 1,021 distinct documents
 * sharing just 40 file names, so hundreds of rows all read "History_and_physical_note.bin" and the
 * Find list looks like the same document repeated -- which is how it gets reported as documents
 * replicating (CV-468), even though every row is a different document with its own Athena id.
 *
 * The document's own date is what actually distinguishes them, so it leads. The description follows
 * when it says something the file name does not.
 */
export const documentSubtitle: (
  doc: Partial<CatSearchDocType> | null | undefined
) => string = (doc) => {
  const parts: string[] = [];

  const stamp = doc?.documentationDatetime || doc?.indexedDate || "";
  const when = stamp ? dayjs(stamp) : null;
  if (when && when.isValid()) {
    // Date-only documents arrive stamped at midnight -- a large share of them, since the source
    // often carries a date with no clock. Rendering "00:00" would claim a precision the document
    // never had, so the time shows only when it carries information.
    const midnight = when.hour() === 0 && when.minute() === 0;
    parts.push(
      midnight ? when.format("DD MMM YYYY") : when.format("DD MMM YYYY, HH:mm")
    );
  }

  const description = (doc?.documentDescription || "").trim();
  const name = (doc?.documentName || "").trim();
  if (description && description !== name) {
    parts.push(description);
  }

  return parts.join(" · ");
};

export default { FormatCatSearch };
